// Tracks in-flight API requests so buttons can show a loader while a call is pending.
let pending = 0;
let started = 0;
const listeners = new Set();

const notify = () => listeners.forEach((fn) => fn());

export const requestTracker = {
  start() {
    pending += 1;
    started += 1;
    notify();
  },
  end() {
    pending = Math.max(0, pending - 1);
    notify();
  },
  getPending: () => pending,
  getStarted: () => started,
  subscribe(fn) {
    listeners.add(fn);
    return () => listeners.delete(fn);
  },
};
